import React from "react";
import { 
  Container, 
  Row, 
  NavItem,
  NavLink,
  Nav 
} from "reactstrap";
import classnames from "classnames";

const ProductHeader = ({ tabs, toggleNavs }) => {
  return (
    <>
      <div className="header bg-gradient-warning pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body mx-3">
            <Row>
              <Nav pills className="nav-fill flex-column flex-md-row mb-3">
                <NavItem>
                  <NavLink
                    aria-selected={tabs === 1}
                    className={classnames("mb-sm-3 mb-md-0", {
                      active: tabs === 1
                    })}
                    onClick={e => toggleNavs(e, "tabs", 1)}
                    href="#"
                  >
                    Produk Aktif
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    aria-selected={tabs === 2}
                    className={classnames("mb-sm-3 mb-md-0", {
                      active: tabs === 2
                    })}
                    onClick={e => toggleNavs(e, "tabs", 2)}
                    href="#"
                  >
                    Produk Tidak Aktif
                  </NavLink>
                </NavItem>
              </Nav>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ProductHeader;